// extracted by mini-css-extract-plugin
export var alignCenter = "_bv-d";
export var bannerShown = "_bv-6";
export var buttonContent = "_bv-0";
export var cardList = "_bv-1";
export var centerContent = "_bv-2";
export var chevron = "_bv-3";
export var closePanelButton = "_bv-k";
export var conversationContextContainer = "_bv-l";
export var conversationDetailContainer = "_bv-4";
export var detailWrapper = "_bv-7";
export var dropdownButton = "_bv-e";
export var dropdownTitle = "_bv-9";
export var fullHeight = "_bv-5";
export var hidden = "_bv-a";
export var icon = "_bv-b";
export var mergeSuggestionWrapper = "_bv-m";
export var panel = "_bv-i";
export var portalButtonsWrapper = "_bv-c";
export var right = "_bv-j";
export var tableSummaryContainer = "_bv-8";
export var tableSummaryHeader = "_bv-g";
export var threeDotsButton = "_bv-f";
export var wide = "_bv-h";